import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRoot from './App';

// Polyfills for Buffer and process
import { Buffer } from 'buffer';
import process from 'process';

window.Buffer = Buffer;
window.process = process;

const rootEl = document.getElementById('root');
rootEl.setAttribute('contenteditable', 'false');
document.body.setAttribute('contenteditable', 'false');

const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <AppRoot />
  </React.StrictMode>
);
